import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, CONTACT_EMAIL } from "@/data/site";
import { scrollToAnchor } from "@/components/site/Header";

export const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goTo = (anchor) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToAnchor(anchor), 350);
    } else scrollToAnchor(anchor);
  };

  return (
    <footer className="relative border-t border-white/[0.06] bg-[#05060f]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Link to="/" aria-label="Les Amis du Web — Accueil" className="inline-block" data-testid="footer-logo-link">
              <img
                src="/logo-amisduweb.png"
                alt="Les Amis du Web — création de sites internet sur mesure"
                className="h-14 w-auto"
                data-testid="footer-logo"
              />
            </Link>
            <p className="text-[var(--text-secondary)] mt-4 max-w-sm leading-relaxed">
              Création de sites internet sur mesure. Des sites modernes, rapides et pensés pour transformer vos
              visiteurs en clients.
            </p>
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="link-underline inline-flex items-center gap-1.5 mt-6 text-sm text-[var(--accent-cyan)]"
              data-testid="footer-email"
            >
              {CONTACT_EMAIL} <ArrowUpRight size={14} />
            </a>
          </div>

          <div className="md:col-span-4">
            <p className="section-label mb-5">Navigation</p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.map((l) =>
                l.to ? (
                  <Link key={l.label} to={l.to} className="text-left text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                    {l.label}
                  </Link>
                ) : (
                  <a
                    key={l.anchor}
                    href={l.anchor === "accueil" ? "/" : `/#${l.anchor}`}
                    onClick={(e) => {
                      e.preventDefault();
                      goTo(l.anchor);
                    }}
                    className="text-left text-sm text-[var(--text-secondary)] hover:text-white transition-colors"
                    data-testid={`footer-link-${l.anchor}`}
                  >
                    {l.label}
                  </a>
                )
              )}
              <Link to="/demande" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="footer-link-contact">
                Contact
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="section-label mb-5">Informations</p>
            <div className="flex flex-col gap-3">
              <Link to="/creation-site-internet" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="footer-link-creation">
                Création de site internet
              </Link>
              <Link to="/conseils" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="footer-link-conseils">
                Conseils
              </Link>
              <Link to="/confidentialite" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="footer-link-confidentialite">
                Confidentialité & mentions
              </Link>
              <Link to="/demande" className="text-sm text-[var(--text-secondary)] hover:text-white transition-colors" data-testid="footer-link-apercu">
                Demander un aperçu gratuit
              </Link>
              <Link to="/admin" className="text-sm text-[var(--text-muted)] hover:text-white transition-colors" data-testid="footer-link-admin">
                Espace privé
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/[0.05] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-[var(--text-muted)]">
            © {new Date().getFullYear()} Les Amis du Web — Création de sites internet sur mesure.
          </p>
          <p className="font-mono-label text-[10px] tracking-[0.25em] uppercase text-[var(--text-muted)]">
            Développeurs web par passion
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
